import { environment } from '../environments/environment';

console.log('production?', environment.production);

let baseUrl = 'https://dev.finops.nl';

// Override so local can access staging
baseUrl = 'https://dev.finops.nl';

if (environment.production) {
  baseUrl = '';
}

export const config = {
  api: {
    host: baseUrl,
    client_secret: 'F8x52plQDMlS0g2l3GqQIomWjhxNd5aS1coexUMF',
    client_id: '1',
    shard: 'finops',
  }
};
